import { DeviceType, Host, HostMap, IssuesFilter } from 'services/pangolin/types';
import { hostDisplayDeviceType } from 'services/pangolin/hosts_service';

export type DeviceEntry = { kind: DeviceType; host: Host };

export const getDeviceEntryID = (entry: DeviceEntry): string => {
  return entry.host.id;
};

export const hostToDeviceEntry = (host: Host): DeviceEntry => {
  return {
    kind: hostDisplayDeviceType(host),
    host,
  };
};

export function createDeviceEntries(filter: IssuesFilter, hosts: HostMap): DeviceEntry[] {
  const entries: DeviceEntry[] = [];

  filter.devices.forEach((host_id) => {
    const host = hosts.get(host_id);
    if (host) entries.push({
      kind: hostDisplayDeviceType(host),
      host,
    });
  });

  return entries;
}
